module.exports = "https://bin.bnbstatic.com/_next/static/images/usdt_app_cn-2451d5160fac442d6777ef497284eb38.png";